import { FormikProps } from 'formik';

import { touchAllErrorPaths } from './touchAllErrors';

export async function forceShowFormValidationErrors<T>(formik: FormikProps<T>): Promise<boolean> {
  const errors = await formik.validateForm();
  const hasErrors = Boolean(errors && Object.keys(errors).length > 0);
  if (hasErrors) {
    formik.setErrors(errors);
    touchAllErrorPaths(formik.setTouched, errors);
  }
  return hasErrors;
}
